import _ from 'lodash';
import { useCallback } from 'react';
import { createGlobalState } from 'react-use';
import { Game as GameType } from '~types';

type Game = GameType & {
  antimate: boolean;
};

const useItemsInContractValue = createGlobalState<Game[]>([]);
const useIdsItemsInContractValue = createGlobalState<number[]>([]);
const useContractAmountValue = createGlobalState(0);
const useWinItemValue = createGlobalState(0);

export const useIdsItemsInContract = () => useIdsItemsInContractValue();
export const useContractAmount = () => useContractAmountValue();
export const useWinItem = () => useWinItemValue();

type IUseItemsInContract = [Game[], (state: Game[]) => Game[]];

export const useItemsInContract = (): IUseItemsInContract => {
  const [, setIdsItemsInContract] = useIdsItemsInContract();
  const [itemsInContract, setItems] = useItemsInContractValue();

  const setItemsInContract = useCallback(
    (items: Game[]) => {
      setItems(items);
      setIdsItemsInContract(_.map(items, 'id'));

      return items;
    },
    [setIdsItemsInContract, setItems],
  );

  return [itemsInContract, setItemsInContract];
};
